<template>
  <div>
    <div class="goodsContainer">
      <div class="goods">
        <div class="goodsTable">
          <table>
            <thead>
              <tr>
                <th>序号</th>
                <th>收货人</th>
                <th>所属地区</th>
                <th>详细地址</th>
                <th>联系方式</th>
                <th>操作</th>
                <th>默认地址</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in shaddressList" :key="item.id" :id="item.id">
                <td>地址{{ item.id }}</td>
                <td>
                  <input
                    type="text"
                    class="consignee input"
                    v-model="item.bperson"
                    :disabled="isShow"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="phone input"
                    v-model="item.barea"
                    :disabled="isShow"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="site input"
                    v-model="item.baddress"
                    :disabled="isShow"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="phone input"
                    v-model="item.blinktype"
                    :disabled="isShow"
                  />
                </td>
                <td>
                  <a href="javascript:void(0);" @click="editChange(item)"
                    >编辑</a
                  >
                  <a href="javascript:void(0);" @click="deleteChange(item.id)"
                    >删除</a
                  >
                </td>
                <td>
                  <input
                    type="checkbox"
                    class="checkbox"
                    v-model="item.isdef"
                    @click="selchk"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="btn">
            <button @click="saveshinfoChange">保存</button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="收货地址" :visible.sync="siteDialogVisible" width="50%">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="收货人" prop="consignee">
          <el-input v-model="form.consignee" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属地区" prop="city">
          <el-cascader :options="cityData" v-model="form.city"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailed">
          <el-input v-model="form.detailed" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="form.phone" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="siteDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="siteDialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cityData from "../../../../public/citydata";
import { getshaddress, saveshinfo } from "@/api";
let id = "";
export default {
  data() {
    return {
      shaddressList: [],
      cityData,
      isShow: true,
      siteDialogVisible: false,
      form: {
        consignee: "",
        detailed: "",
        city: [],
        phone: "",
      },
      rules: {
        consignee: {
          required: true,
          message: "请填写收货人",
          trigger: "blur",
        },
        detailed: {
          required: true,
          message: "请选择所属地区",
          trigger: "blur",
        },
        city: {
          required: true,
          message: "请填写详细地址",
          trigger: "blur",
        },
        phone: {
          required: true,
          message: "请填写联系方式",
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    selchk(event) {
      const checkboxs = document.querySelectorAll("td .checkbox");
      checkboxs.forEach((item) => {
        item.checked = false;
      });
      event.target.checked = true;
    },
    async getshaddressList() {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await getshaddress({ usercode, token });
      this.shaddressList = JSON.parse(res);
      console.log(this.shaddressList);
    },
    editChange(row) {
      id = row.id - 1;
      this.siteDialogVisible = true;
      this.form.consignee = row.bperson;
      this.form.phone = row.blinktype;
      this.form.detailed = row.baddress;
      const arr = row.barea.split("/");
      this.form.city = arr;
    },
    deleteChange(id) {
      var editTR = document.getElementById(id);
      var inputs = editTR.querySelectorAll("td .input");
      var checkbox = editTR.querySelector("td .checkbox");
      inputs.forEach((item) => {
        item.value = "";
      });
      checkbox.checked = false;
    },
    async saveshinfoChange() {
      let arr = [];
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      var inputVaules = document.querySelectorAll("table td input");
      inputVaules.forEach((item) => {
        if (item.type == "text") {
          arr.push(item.value);
        } else {
          if (item.checked) {
            arr.push("1");
          } else {
            arr.push("0");
          }
        }
      });
      var result = [];
      for (var i = 0; i < arr.length; i += 5) {
        result.push({
          shperson: arr.slice(i, i + 1)[0],
          barea: arr.slice(i + 1, i + 2)[0],
          shaddress: arr.slice(i + 2, i + 3)[0],
          linktype: arr.slice(i + 3, i + 4)[0],
          isdef: arr.slice(i + 4, i + 5)[0],
        });
      }
      result = JSON.stringify(result);
      const { data: res } = await saveshinfo({ usercode, token, json: result });
      const Resvalue = JSON.parse(res)[0];
      if (Resvalue.code !== 200) {
        this.$notify.error({
          title: "错误",
          message: Resvalue.message,
          duration: 1000,
        });
      } else {
        this.$notify({
          title: "成功",
          message: Resvalue.message,
          type: "success",
          duration: 1000,
        });
        this.getshaddressList();
      }
    },
    siteDialogConfirm() {
      const { form } = this;
      let str = "";
      form.city.forEach((item, index) => {
        if (index == 0) {
          str += item;
        } else {
          str += "/" + item;
        }
      });
      this.shaddressList[id].bperson = form.consignee;
      this.shaddressList[id].barea = str;
      this.shaddressList[id].blinktype = form.phone;
      this.shaddressList[id].baddress = form.detailed;
      this.$notify({
        title: "成功",
        message: "编辑成功!",
        type: "success",
        duration: 1000,
      });
      this.siteDialogVisible = false;
    },
  },
  mounted() {
    this.getshaddressList();
  },
};
</script>
<style lang='less' scoped>
.goodsContainer {
  margin-bottom: 20px;
  .goods {
    .goodsTable {
      .btn {
        padding-bottom: 100px;
        text-align: center;
        button {
          width: 150px;
          height: 35px;
          color: #fff;
          background: #e4040c;
        }
      }
      table {
        .consignee {
          width: 80px;
          height: 45px;
          line-height: 45px;
          text-align: center;
        }
        .site {
          width: 250px;
          height: 30px;
          text-align: left;
          padding: 8px 5px;
        }
        .phone {
          width: 90px;
          height: 45px;
          line-height: 45px;
          text-align: center;
        }
        input {
          border: 1px solid #cccccc;
          background: #fff;
        }
      }
      border: 1px solid #cccccc;
      table thead tr {
        background: #f3f4f6;
        border-bottom: 1px solid #cccccc;
      }
      table tr th {
        width: 150px;
        height: 35px;
        line-height: 35px;
        color: #757575;
      }
      table tbody tr td {
        padding: 40px 0;
        a {
          padding: 0 5px;
          color: #3485fb;
        }
      }
      table tr td {
        text-align: center;
      }
    }
  }
}
</style>